import { AloftArea, AloftPrice } from '@aloft/toolkit-shared';
import { Td, Tr } from '@aloft/toolkit-sui';

import { useAppSelector } from '../../redux/hooks.ts';
import { RootState } from '../../redux/types.ts';
import { Typography } from '../../summary/components/Typography.tsx';
import { getCostString } from './utils/getCostString.ts';
import { getPricePerSquareFoot } from './utils/getPricePerSquareFoot.ts';

export const CostApproachTableCostRow = ({
  label,
  areaSelector,
  costSelector,
}: {
  label: string;
  areaSelector: (state: RootState, id: string) => AloftArea | undefined;
  costSelector: (state: RootState, id: string) => AloftPrice | undefined;
}) => {
  const area = useAppSelector((state) => areaSelector(state, 'subject'));
  const cost = useAppSelector((state) => costSelector(state, 'subject'));

  const price = getPricePerSquareFoot(area, cost);

  return (
    <Tr>
      <Td>
        <Typography variant="body1">{label}</Typography>
      </Td>
      <Td colSpan={3}>{area?.toSqFt().toString()}</Td>
      <Td colSpan={3}>{price ? `${price.toString()} per sqft` : null}</Td>
      <Td className="cost-approach-table-align-right">{getCostString(cost)}</Td>
    </Tr>
  );
};
